import { toast } from '@finn-no/common-browserbundle';
import * as fetchService from '../services/jsonfetchservice';

export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingService) {
        Array.from(ele.querySelectorAll('.tags-input')).forEach(element =>
            element.addEventListener('click', tagClicked)
        );

        ele
            .querySelector('#post-feedback-button')
            .addEventListener('click', postFeedback);

        ele
            .querySelector('#expandfields')
            .addEventListener('click', expandField);

        const adId = getAdIdFromURL();
        let response = [];
        let hasSentBefore = false;

        // counts number of checked checkboxes
        const countCheckboxes = () =>
            Array.from(ele.querySelectorAll('.tags-input')).filter(
                element => element.type === 'checkbox' && element.checked
            ).length;

        const disableAllUncheckedCheckboxes = disable => {
            Array.from(ele.querySelectorAll('.tags-input')).map(element => {
                if (element.type === 'checkbox' && !element.checked) {
                    element.disabled = disable;
                }

                return element;
            });
        };

        // Each time user clicks a tag.
        function tagClicked(event) {
            const numOfTagsChecked = countCheckboxes();
            const numOfTagsCheckedFromGET = response.filter(
                item => item.checked
            ).length;

            // If it exceeds 3 then we disable the other boxes
            disableAllUncheckedCheckboxes(numOfTagsChecked >= 3);

            // we disable the postfeedbackbutton by default and does not make it available before after at least one box is checked.
            if (
                numOfTagsChecked > 0 ||
                numOfTagsCheckedFromGET > 0 ||
                hasSentBefore
            ) {
                ele.querySelector('#post-feedback-button').disabled = false;
            } else {
                ele.querySelector('#post-feedback-button').disabled = true;
            }

            if (event) {
                trackingService.trackEventObject({
                    analyticsName: 'feedback.tag-clicked',
                    eventFlags: 'success',
                    kpi: 'effect',
                    ecType: 'USER',
                    ecCategory: `feedback.tag-clicked&feedbackTag=${event.target
                        .value}`,
                    context: {
                        finnkode: adId,
                    },
                });
            }
        }

        function getFeedbackForAd(adId) {
            return fetchService
                .get(`/feedback-types.json?finnkode=${adId}`, {
                    headers: { 'content-type': 'application/json' },
                    credentials: 'same-origin',
                })
                .then(res => {
                    if (res.ok) {
                        return res;
                    }

                    throw new Error(res);
                })
                .then(res => res.json());
        }

        // post feedback to our API
        function postFeedback() {
            hasSentBefore = true;
            const postButton = ele.querySelector('#post-feedback-button');
            postButton.classList.add('inprogress');
            postButton.disabled = true;
            getFeedbackForAd(adId)
                .then(res => {
                    response = res;
                    const userId = document.querySelector(
                        'meta[name="FINN.userid"]'
                    ).content;
                    const checkedFeedbackTypesArray = [];

                    response.forEach(item => {
                        Array.from(ele.querySelectorAll('.tags-input'))
                            .filter(
                                element =>
                                    element.type === 'checkbox' &&
                                    element.value === item.tag &&
                                    element.checked !== item.checked
                            )
                            .forEach(element => {
                                checkedFeedbackTypesArray.push({
                                    userId,
                                    adId,
                                    feedbackType: element.value,
                                });
                            });
                    });

                    return fetchService.put(
                        '/feedback.json',
                        checkedFeedbackTypesArray
                    );
                })
                .then(() => {
                    ele.querySelector('#post-feedback-button').disabled = false;
                    toast({ message: 'Takk, du vil nå bli varslet!' });
                    ele
                        .querySelector('#post-feedback-button')
                        .classList.remove('inprogress');
                    ele.querySelector('#tags-ok-toast').hidden = false;
                    ele.querySelector('#expandfields').open = false;
                    ele
                        .querySelector('#arrow')
                        .setAttribute('class', 'expand-arrow');
                })
                .catch(() => {
                    postButton.disabled = false;
                    postButton.classList.remove('inprogress');
                    toast({
                        message:
                            'Ops... Noe gikk galt da vi skulle sende inn din forespørsel. Prøv igjen om litt!',
                        level: 'error',
                    });
                });

            trackingService.trackEventObject({
                analyticsName: 'feedback.submitted',
                eventFlags: 'success',
                kpi: 'effect',
                ecType: 'USER',
                ecCategory: 'feedback.submitted',
                context: {
                    finnkode: adId,
                },
            });
        }

        const highlightCheckedTags = response => {
            response.filter(item => item.checked).forEach(item => {
                Array.from(ele.querySelectorAll('.tags-input')).map(element => {
                    if (
                        element.value === item.tag &&
                        element.type === 'checkbox'
                    ) {
                        element.checked = true;
                    }

                    return element;
                });
            });
        };

        function getAdIdFromURL() {
            const url = new URL(window.location.href);
            return url.searchParams.get('finnkode');
        }

        function expandField() {
            if (ele.querySelector('#expandfields').open === true)
                ele
                    .querySelector('#arrow')
                    .setAttribute('class', 'collapse-arrow');
            else
                ele
                    .querySelector('#arrow')
                    .setAttribute('class', 'expand-arrow');

            trackingService.trackEventObject({
                analyticsName: 'feedback.expanded',
                eventFlags: 'success',
                kpi: 'effect',
                ecType: 'USER',
                ecCategory: 'feedback.expanded',
                context: {
                    finnkode: adId,
                },
            });
        }

        return getFeedbackForAd(adId)
            .then(res => {
                response = res;
                highlightCheckedTags(response);
                tagClicked();
            })
            .catch(() => (ele.hidden = true));
    },
};



// WEBPACK FOOTER //
// ./controllers/adFeedback.js